export default "__VITE_ASSET__qVRr305S__"